import styled, { css } from "styled-components";

export const Container = styled.div`
  background: transparent;
  border-radius: 5px;
  border: 1px solid #dadada;
  padding: 8px;
  color: #dadada;
  display: flex;
  align-items: center;
  flex: 1;
  @media (max-width: 500px) {
    width: 100%;
  }
  & + div {
    margin-top: 24px;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: #5ddb98;
      border-color: #5ddb98;
    `}
  
  ${(props) =>
    props.isFilled &&
    css`
      color: #5ddb98;
    `}
  
  input[type=number] {
    -moz-appearance: textfield;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.7;
      background-color: #f2f2f2;
    `}

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.7;
      background-color: #f2f2f2;
    `}

  input {
    background: transparent;
    font-size: 14px;
    border: 0;
    flex: 1;
    color: #002244;
    padding: 8px;
    width: 100%;
    &::placeholder {
      color: #002244;
    }
    &:focus {
      border: 0;
      outline: none;
    }
  }
  svg {
    margin-right: 16px;
  }
`;

export const Error = styled.div`
  margin: 5px 0px !important;
  display: flex;
  font-size: 10px;
  align-items: center;
  justify-content: flex-start;
  color: #e00000;
  text-align: left;
  svg {
    margin-right: 4px;
    /* margin-left: 16px; */
    min-width: 32px;
  }
  span {
    background: #c53030;
    color: #fff;
    &::before {
      border-color: #c53030 transparent;
    }
  }

  ${(props) =>
    props.labelWidth &&
    css`
      margin-left: ${props.labelWidth} !important;
      @media (max-width: 500px) {
        margin-left: 0px !important;
      }
    `}
`;

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const Label = styled.span`
  margin-right: 8px;
  font-size: 12px;
  font-weight: 600;
  /* width: 100px; */
  ${(props) =>
    props.labelWidth &&
    css`
      width: ${props.labelWidth};
    `}
  word-wrap: break-word;
  @media (max-width: 500px) {
    margin-bottom: 8px;
    width: 100%;
  }
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const AsteriskText = styled.span`
  color: #c53030;
`;

export const Description = styled.span`
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
  font-weight: 600;
  line-height: 18.86px;
  display: table;
`;
